import ProtectedLayout from './ProtectedLayout'
import PublicLayout from './PublicLayout'
import GuestNotificationLayout from './GuestNotificationLayout'

export default { ProtectedLayout, PublicLayout, GuestNotificationLayout }
